import * as React from 'react'
import { Sidebar } from '../BulkActionsSidebar'
import { ActivityFormFields } from '@user/features/Activity/components/ActivityForm/ActivityFormFields'
import {
  useInitValues,
  useValidations,
} from '@user/features/Activity/components/ActivityForm/hooks'
import { ENTITY_TYPES } from '@sales-center/common'
import { ActivitiesContextProvider } from '@user/features/Activity/context'
import { useFetchActivityTypes } from '@user/features/Activity/hooks'
import { useActions, useData } from './hooks'
import { useGetSalesTeamUsers } from '@user/store/salesTeam'

type Props = {
  entityType: ENTITY_TYPES
}

export function BulkAddActivities(props: Props) {
  const { validate } = useValidations()
  const { onSubmit } = useActions(props)
  const { quantity, salesTeamId, ownerId, owners } = useData(props)
  const initValues = useInitValues(ownerId)

  useFetchActivityTypes()
  useGetSalesTeamUsers(+salesTeamId)

  return (
    <Sidebar
      title="add activity"
      initialValues={initValues}
      onSubmit={onSubmit}
      validate={validate}
      validateOnBlur={true}
      saveDisabled={false}
    >
      {owners?.length && (
        <ActivityFormFields
          entityType={props.entityType}
          quantity={quantity}
          salesTeamId={salesTeamId}
          ownerId={ownerId}
          owners={owners}
        />
      )}
    </Sidebar>
  )
}

export function BulkAddLeadActivities() {
  return (
    <ActivitiesContextProvider>
      <BulkAddActivities entityType={ENTITY_TYPES.Lead} />
    </ActivitiesContextProvider>
  )
}

export function BulkAddOppsActivities() {
  return (
    <ActivitiesContextProvider>
      <BulkAddActivities entityType={ENTITY_TYPES.Opportunity} />
    </ActivitiesContextProvider>
  )
}
